/*
 * See https://github.com/commonpike/add-to-calendar-buttons
 */

/* --------------
       config 
    --------------- */

const MS_IN_MINUTES = 60 * 1000;

/* --------------
      browser sniffing 
    --------------- */

// ie < edg (=chromium) doesnt support data-uri:text/calendar
const ieCanDownload = "msSaveOrOpenBlob" in window.navigator;
const ieMustDownload = /\b(MSIE |Trident.*?rv:|Edge\/)(\d+)/.exec(
  navigator.userAgent,
);

/* --------------
      generators 
    --------------- */

export const google = function (inEvent) {
  let startTime, endTime;
  const event = convertEvent(inEvent);

  if (event.allday) {
    // google wants 2 consecutive days at 00:00
    startTime = formatTime(event.tzstart);
    endTime = formatTime(getEndDate(event.tzstart, 60 * 24));
    startTime = stripISOTime(startTime);
    endTime = stripISOTime(endTime);
  } else {
    if (event.timezone) {
      // google is somehow weird with timezones.
      // it works better when giving the local
      // time in the given timezone without the zulu,
      // and pass timezone as argument.
      // but then the dates we have loaded
      // need to shift inverse with tzoffset the
      // browser gave us.
      // so
      let shiftstart, shiftend;
      shiftstart = new Date(
        event.start.getTime() - event.start.getTimezoneOffset() * MS_IN_MINUTES,
      );
      if (event.end) {
        shiftend = new Date(
          event.end.getTime() - event.end.getTimezoneOffset() * MS_IN_MINUTES,
        );
      }
      startTime = formatTime(shiftstart);
      endTime = formatTime(shiftend);
      // strip the zulu and pass the tz as argument later
      startTime = startTime.substring(0, startTime.length - 1);
      endTime = endTime.substring(0, endTime.length - 1);
    } else {
      // use regular times
      startTime = formatTime(event.start);
      endTime = formatTime(event.end);
    }
  }

  return encodeURI(
    [
      "https://www.google.com/calendar/render",
      "?action=TEMPLATE",
      "&text=" + (event.title || ""),
      "&dates=" + (startTime || ""),
      "/" + (endTime || ""),
      event.timezone ? "&ctz=" + event.timezone : "",
      "&details=" + (event.description || ""),
      "&location=" + (event.address || ""),
      "&sprop=&sprop=name:",
    ].join(""),
  );
};

export const yahoo = function (event) {
  let yahooEventDuration;
  if (event.allday) {
    yahooEventDuration = "allday";
  } else {
    let eventDuration = event.tzend
      ? (event.tzend.getTime() - event.tzstart.getTime()) / MS_IN_MINUTES
      : event.duration;

    // Yahoo dates are crazy, we need to convert the duration from minutes to hh:mm

    let yahooHourDuration =
      eventDuration < 600
        ? "0" + Math.floor(eventDuration / 60)
        : Math.floor(eventDuration / 60) + "";

    let yahooMinuteDuration =
      eventDuration % 60 < 10
        ? "0" + (eventDuration % 60)
        : (eventDuration % 60) + "";

    yahooEventDuration = yahooHourDuration + yahooMinuteDuration;
  }

  // Remove timezone from event time
  // var st = formatTime(new Date(event.start - (event.start.getTimezoneOffset() * MS_IN_MINUTES))) || '';

  var st = formatTime(event.tzstart) || "";

  return encodeURI(
    [
      "http://calendar.yahoo.com/?v=60&view=d&type=20",
      "&title=" + (event.title || ""),
      "&st=" + st,
      "&dur=" + (yahooEventDuration || ""),
      "&desc=" + (event.description || ""),
      "&in_loc=" + (event.address || ""),
    ].join(""),
  );
};

export const off365 = function (event) {
  var startTime = formatTime(event.tzstart);
  var endTime = formatTime(event.tzend);

  return encodeURI(
    [
      "https://outlook.office365.com/owa/",
      "?path=/calendar/action/compose",
      "&rru=addevent",
      "&subject=" + (event.title || ""),
      "&startdt=" + (startTime || ""),
      "&enddt=" + (endTime || ""),
      "&body=" + (event.description || ""),
      "&location=" + (event.address || ""),
      "&allday=" + event.allday ? "true" : "false",
    ].join(""),
  );
};

export const ics = function (event, eClass, calendarName) {
  var startTime, endTime;

  if (event.allday) {
    // DTSTART and DTEND need to be equal and 0
    startTime = formatTime(event.tzstart);
    endTime = startTime = stripISOTime(startTime) + "T000000";
  } else {
    startTime = formatTime(event.tzstart);
    endTime = formatTime(event.tzend);
  }

  var cal = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "BEGIN:VEVENT",
    "URL:" + document.URL,
    "DTSTART:" + (startTime || ""),
    "DTEND:" + (endTime || ""),
    "SUMMARY:" + (event.title || ""),
    "DESCRIPTION:" + (event.description || ""),
    "LOCATION:" + (event.address || ""),
    "UID:" + (event.id || "") + "-" + document.URL,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\n");

  if (ieMustDownload) {
    return (
      '<a class="' +
      eClass +
      '" onclick="ieDownloadCalendar(\'' +
      escapeJSValue(cal) +
      "')\">" +
      calendarName +
      "</a>"
    );
  }

  return encodeURI("data:text/calendar;charset=utf8," + cal);
};

/* --------------
       helpers 
    --------------- */

const formatTime = function (date) {
  return date ? date.toISOString().replace(/-|:|\.\d+/g, "") : "";
};

const getEndDate = function (start, duration) {
  return new Date(start.getTime() + duration * MS_IN_MINUTES);
};

const stripISOTime = function (isodatestr) {
  return isodatestr.substr(0, isodatestr.indexOf("T"));
};

const escapeJSValue = function (text) {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/\'/g, "\\'")
    .replace(/(\r?\n|\r)/gm, "\\n");
};

const ieDownloadCalendar = function (cal) {
  if (ieCanDownload) {
    var blob = new Blob([cal], { type: "text/calendar" });
    window.navigator.msSaveOrOpenBlob(blob, "Calendar-event.ics");
  } else {
    alert("Sorry, your browser does not support downloading Calendar events.");
  }
};

const convertEvent = (event) => ({
  ...event,
  start: new Date(event.date),
  end: new Date(event.date),
});
